// WebSocket 主线程代理层 - 通过 Web Worker 处理 WebSocket 连接
let worker = null;
let connectCallBack = null;
let messageCallBack = null;
let closeCallBack = null;

// 初始化 Worker
const initWorker = () => {
	if (worker) {
		return worker;
	}
	
	try {
		// 创建 Web Worker - 使用独立的 Worker 文件
		// Worker 文件放在 public 目录，使用绝对路径加载
		const workerUrl = process.env.NODE_ENV === 'production' 
			? '/wssocket.worker.js'  // 生产环境
			: '/wssocket.worker.js';  // 开发环境（public 目录的文件）
		
		worker = new Worker(workerUrl);
		
		// 监听 Worker 消息
		worker.onmessage = function (e) {
			// 安全检查
			if (!e || !e.data) {
				console.warn('Worker 消息格式错误:', e);
				return;
			}
			
			const { type, data } = e.data;
			
			switch (type) {
				case 'connect':
					// WebSocket 连接成功
					connectCallBack && connectCallBack();
					break;
				case 'message':
					// 收到消息 - 添加安全检查
					if (data && typeof data.cmd !== 'undefined') {
						messageCallBack && messageCallBack(data.cmd, data.data || null);
					} else {
						console.warn('Worker 消息数据格式错误:', data);
					}
					break;
				case 'close':
					// 连接关闭
					closeCallBack && closeCallBack(data || {});
					break;
				case 'error':
					// 连接错误
					console.error('WebSocket Worker 错误');
					break;
				default:
					console.warn('未知的 Worker 消息类型', type);
			}
		};
		
		// Worker 错误处理
		worker.onerror = function (error) {
			console.error('WebSocket Worker 发生错误:', error);
		};
		
		console.log('Worker 创建成功');
		return worker;
	} catch (error) {
		console.error('创建 WebSocket Worker 失败:', error);
		// 如果 Worker 不支持，可以降级到主线程（可选）
		throw error;
	}
};

// 连接 WebSocket
let connect = (wsurl, accessToken) => {
	try {
		const w = initWorker();
		w.postMessage({
			type: 'connect',
			data: {
				wsurl: wsurl,
				accessToken: accessToken
			}
		});
		console.log("主线程: 发送连接请求到 Worker");
	} catch (e) {
		console.error("主线程: 连接失败", e);
	}
};

// 定义重连函数
let reconnect = (wsurl, accessToken) => {
	try {
		const w = initWorker();
		w.postMessage({
			type: 'reconnect',
			data: {
				wsurl: wsurl,
				accessToken: accessToken
			}
		});
		console.log("主线程: 发送重连请求到 Worker");
	} catch (e) {
		console.error("主线程: 重连失败", e);
	}
};

// 设置关闭连接
let close = (code) => {
	try {
		const w = initWorker();
		w.postMessage({
			type: 'close',
			data: {
				code: code
			}
		});
		console.log("主线程: 发送关闭请求到 Worker");
	} catch (e) {
		console.error("主线程: 关闭失败", e);
	}
};

// 发送消息
let sendMessage = (agentData) => {
	try {
		const w = initWorker();
		w.postMessage({
			type: 'sendMessage',
			data: agentData
		});
	} catch (e) {
		console.error("主线程: 发送消息失败", e);
	}
};

// 注册连接成功回调
let onConnect = (callback) => {
	connectCallBack = callback;
};

// 注册消息回调
let onMessage = (callback) => {
	messageCallBack = callback;
};

// 注册关闭回调
let onClose = (callback) => {
	closeCallBack = callback;
};

// 将方法暴露出去
export {
	connect,
	reconnect,
	close,
	sendMessage,
	onConnect,
	onMessage,
	onClose
}
